import cn from 'classnames';

import { useDictionary } from 'src/hooks/useDictionary';
import { useRouteContext } from 'src/hooks/useRouteContext';

import Email from 'assets/icons/envelope.svg';
import Facebook from 'assets/icons/facebook.svg';
import LinkedIn from 'assets/icons/linkedin.svg';
import X from 'assets/icons/twitter-x.svg';

import Text from 'components/BaseHelpers/Text';

import { ComponentProps } from '../../../types/component-props';
import { CoreSocialShareToolsData } from '../../../types/components';

import styles from './CoreSocialShareTools.module.scss';

export type CoreSocialShareToolsProps = ComponentProps & CoreSocialShareToolsData;

const CoreSocialShareTools = (props: CoreSocialShareToolsProps): JSX.Element => {
  const { platforms } = props.fields;
  const { routeData } = useRouteContext();
  const { shareLabel } = useDictionary();

  return (
    <div className={styles.main}>
      <Text className={cn(styles.label, 'body-lg')} field={shareLabel} />
      <ul className={styles.list}>
        {platforms.map((platform, index) => {
          let Icon;
          let shareUrl;
          if (platform === 'facebook') {
            Icon = Facebook;
            shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${routeData?.route.url}`;
          } else if (platform === 'x') {
            Icon = X;
            shareUrl = `https://twitter.com/intent/tweet?url=${routeData?.route.url}`;
          } else if (platform === 'linkedin') {
            Icon = LinkedIn;
            shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${routeData?.route.url}`;
          } else if (platform === 'email') {
            Icon = Email;
            shareUrl = `mailto:?body=${routeData?.route.url}`;
          } else {
            return null; // Skip unsupported platforms
          }

          return (
            <li key={index} className={styles.listItem}>
              <a
                href={shareUrl}
                className={cn(styles.link, 'body-lg')}
                aria-label={`Share on ${platform}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon className={styles.icon} />
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default CoreSocialShareTools;
